import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { SITE_REPORT_ID } from './siteReportId';

const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.VISIBLE_IMPRESSIONS.field,
        FIELDS.IMPRESSIONS.field,
        FIELDS.CLICKS.field,
        FIELDS.VCTR.field,
        FIELDS.AVERAGE_CPC.field,
        FIELDS.CVR.field,
        FIELDS.CONVERSIONS.field,
        FIELDS.CPA.field,
        FIELDS.VCPM.field,
        FIELDS.SPENT.field,
        FIELDS.AVG_BOOST.field,
        FIELDS.CONVERSIONS_VALUE.field,
        FIELDS.ROAS.field,
    ].map(field => generateColumnId(SITE_REPORT_ID, field)),
    [REPORT_PRESET.SETUP]: [
        FIELDS.SITE_ID.field,
        FIELDS.SITE_NAME_ID.field,
        FIELDS.BID_MODIFICATION.field,
        FIELDS.BID_STRATEGY_PER_AFFILIATE.field,
    ].map(field => generateColumnId(SITE_REPORT_ID, field)),
};

// columns used by the 'All' column view
const defaultColumns = [
    FIELDS.PUBLISHER_BLOCKING.field,
    FIELDS.PUBLISHER_BLOCKING_LEVEL.field,
    FIELDS.SITE_NAME.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.CLICKS.field,
    FIELDS.VCTR.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.CVR.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CPA.field,
    FIELDS.VCPM.field,
    FIELDS.SPENT.field,
    FIELDS.BID_MODIFICATION.field,
    FIELDS.BID_STRATEGY_PER_AFFILIATE.field,
].map(field => generateColumnId(SITE_REPORT_ID, field));

const performanceColumns = [
    FIELDS.PUBLISHER_BLOCKING.field,
    FIELDS.PUBLISHER_BLOCKING_LEVEL.field,
    FIELDS.SITE_NAME.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.CLICKS.field,
    FIELDS.VCTR.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.CVR.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CPA.field,
    FIELDS.VCPM.field,
    FIELDS.SPENT.field,
    FIELDS.CONVERSIONS_VALUE.field,
    FIELDS.ROAS.field,
    FIELDS.BID_MODIFICATION.field,
    FIELDS.BID_STRATEGY_PER_AFFILIATE.field,
].map(field => generateColumnId(SITE_REPORT_ID, field));

const setupColumns = [
    FIELDS.PUBLISHER_BLOCKING.field,
    FIELDS.PUBLISHER_BLOCKING_LEVEL.field,
    FIELDS.SITE_NAME.field,
    FIELDS.BID_MODIFICATION.field,
    FIELDS.BID_STRATEGY_PER_AFFILIATE.field,
].map(field => generateColumnId(SITE_REPORT_ID, field));

export { customColumns, defaultColumns, performanceColumns, setupColumns };
